import { getApiBaseUrl } from "./baseUrl";
import { getAccessToken, clearSessionTokens } from "../lib/session";

let authErrorHandler: (() => void) | null = null;
export function setAuthErrorHandler(handler: () => void) {
  authErrorHandler = handler;
}

let tempOverrideToken: string | null = null;
export function setTempOverrideToken(token: string | null) {
  tempOverrideToken = token;
}

function normalizeUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) return url;
  const base = getApiBaseUrl();
  if (!base) {
    throw new Error("API_BASE_URL is missing. Check your environment variables.");
  }
  return url.startsWith("/") ? `${base}${url}` : `${base}/${url}`;
}

function toHeaders(init?: HeadersInit): Headers {
  if (init instanceof Headers) return new Headers(init);
  if (Array.isArray(init)) return new Headers(init);
  return new Headers(init ?? {});
}

async function ensureAuth(headers: Headers): Promise<void> {
  if (headers.has("Authorization")) return;
  const token = tempOverrideToken || (await getAccessToken());
  if (!token) return;
  headers.set("Authorization", `Bearer ${token}`);
}

export async function apiFetchCore<T>(url: string, options: RequestInit = {}): Promise<T> {
  const fullUrl = normalizeUrl(url);

  try {
    const headers = toHeaders(options.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
    await ensureAuth(headers);

    const res = await fetch(fullUrl, { ...options, headers });

    if (!res.ok) {
      if (res.status === 401) {
        console.log(`[Error] Unauthorized access to URL: ${fullUrl}`);
        throw new Error("401_UNAUTHORIZED");
      }
      const errorText = await res.text();
      console.log(`[Error] API error: ${res.status} ${errorText}`);
      throw new Error(`API error: ${res.status} ${errorText}`);
    }

    const text = await res.text();
    if (!text) {
      return {} as T; // 空のレスポンスなら空のオブジェクトを返す
    }
    return JSON.parse(text) as T;
  } catch (error: any) {
    console.log("【詳細エラーログ】", JSON.stringify(error, Object.getOwnPropertyNames(error)));    
    if (error?.message && error.message.includes("401")) {
      throw error;
    }
    console.error(`[apiFetch] 例外発生: ${fullUrl}`, error?.message || error);
    throw error;
  }
}

export async function apiNoContentTypeFetchCore<T>(url: string, options: RequestInit = {}): Promise<T> {
  const fullUrl = normalizeUrl(url);

  try {
    const headers = toHeaders(options.headers);
    await ensureAuth(headers);

    const res = await fetch(fullUrl, { ...options, headers });

    if (!res.ok) {
      if (res.status === 401) {
        console.log(`[Error] Unauthorized access to URL: ${fullUrl}`);
        throw new Error("401_UNAUTHORIZED");
      }
      const errorText = await res.text();
      console.log(`[Error] API error: ${res.status} ${errorText}`);
      throw new Error(`API error: ${res.status} ${errorText}`);
    }

    const text = await res.text();
    if (!text) {
      return {} as T; // 空のレスポンスなら空のオブジェクトを返す
    }
    return JSON.parse(text) as T;
  } catch (error: any) {
    console.log("【詳細エラーログ】", JSON.stringify(error, Object.getOwnPropertyNames(error)));    
    if (error?.message && error.message.includes("401")) {
      throw error;
    }
    console.error(`[apiFetch] 例外発生: ${fullUrl}`, error?.message || error);
    throw error;
  }
}